import { Button, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export function HomeScreen() {
    const navigate = useNavigate();

    const navigateToNewOrder = () => {
        navigate('/zamowienie');
    };

    const navigateToUpdateOrder = () => {
        navigate('/zamowienie-aktualizacja')
    };

    return <Row >
        <h1>Zamówienia formatek</h1>
        <Col className="d-grid" >
            <Button size="lg" className="btn-block" onClick={navigateToNewOrder}>
                Nowe zamówienie
            </Button>
        </Col>
        <Col className="d-grid">
            <Button size="lg" onClick={navigateToUpdateOrder}>
                Zaktualizuj zamówienie
            </Button>
        </Col>
    </Row>
}